import { render, staticRenderFns } from "./RevenuesFooter.vue?vue&type=template&id=5e320d56&"
import script from "./RevenuesFooter.vue?vue&type=script&lang=js&"
export * from "./RevenuesFooter.vue?vue&type=script&lang=js&"
import style0 from "./RevenuesFooter.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports